import { render, staticRenderFns } from "./UserEditMFA.vue?vue&type=template&id=fb8fd262"
import script from "./UserEditMFA.vue?vue&type=script&lang=js"
export * from "./UserEditMFA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports